// extracted by mini-css-extract-plugin
export default {"wrapper":"CrossSectionWindow_wrapper__drLxk","header":"CrossSectionWindow_header__XChKR","footer":"CrossSectionWindow_footer__vM3wa","chart":"CrossSectionWindow_chart__M2eaI"};